import { useUserStore } from 'Stores/userStoreModuleFed'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { shallow } from 'zustand/shallow'
import { useNavigate } from 'react-router-dom'
import { COOKIE_KEYS } from 'Consts/cookies.enum'
import { CookieHelper } from 'Utils/cookieHelper'
import { queryClient } from 'Lib/react-query'
import { useIsFirstLogin } from 'Hooks/useIsFirstLogin'

export const useLogout = () => {
  const { resetFirstLogin } = useIsFirstLogin()
  const { logOut: cleanStore } = useUserStore((state) => ({ logOut: state.logOut }), shallow)
  const { removeSystemMessage } = useAppStore()
  const navigate = useNavigate()

  const logOut = () => {
    cleanStore()
    queryClient.clear()
    if (window.analytics) {
      window.analytics.reset()
    }
    resetFirstLogin()
    Object.keys(COOKIE_KEYS).forEach((key: string) => {
      if (key !== 'AUTH_CODE') {
        CookieHelper().deleteCookie(COOKIE_KEYS[key] as string)
      }
    })
  }

  const logOutUser = () => {
    logOut()
    removeSystemMessage()
    navigate('/login')
  }

  return { logOutUser, logOut }
}
